export const dimensions: IDimensionsPerFlavour = {
    normal: {
        desktop: {
            width: 1000,
            height: 1097.3958333333333,
            ratio: 0.9112482202183199,
        },
        mobile: {
            width: 500,
            height: 877.9166666666667,
            ratio: 0.5695301376364499,
        },
    },
};
